import DynamicTextField from './DynamicTextField';
import React, { useState  } from "react";
const AddAboutYou = () => {

    const handleFieldChange = (name, value) => {
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const [formData, setFormData] = useState({
         Experience: [],
        Specialization: [],
        Achievements: [],
 
    });
    return (                       
        
        <div className="space-y-4">
        Cuentanos Acerca de ti:
        <DynamicTextField
            label="Estudios y Especialización"
            value={formData.Specialization}
            onChange={(newValue) => handleFieldChange("Specialization", newValue)}
        />
        <DynamicTextField
            label="Experiencia Profesional"
            value={formData.Experience}
            onChange={(newValue) => handleFieldChange("Experience", newValue)}
        />
        <DynamicTextField
            label="Logros Académicos o Profesionales"
            value={formData.Achievements}
            onChange={(newValue) => handleFieldChange("Achievements", newValue)}
        />
        <DynamicTextField
            label="Zona de atención"
            value={formData.Area}
            onChange={(newValue) => handleFieldChange("Area", newValue)}
        />
    </div>
    );
        
    } 
    export default AddAboutYou;
